import React from 'react'
import { useChatContext, useMessageContext } from 'stream-chat-react';
import MessageReceivedIcon from '../../icons/MessageReceivedIcon';
import MessageReceivedAndReadIcon from '../../icons/MessageReceivedAndReadIcon';
import MessageSendingIcon from '../../icons/MessageSendingIcon';
import MessageUnknownIcon from '../../icons/MessageUnknownIcon';

const statusIconMap = {
    received: <MessageReceivedIcon />,
    receivedAndRead: <MessageReceivedAndReadIcon />,
    sending: <MessageSendingIcon />,
    unknown: <MessageUnknownIcon />,
};

const CustomMessageStatus = () => {
    const {
        message: {
            status = "unknown",
            user,
        },
        readBy = [],
    } = useMessageContext();
    const { client } = useChatContext();
    const [firstUser] = readBy;
    const receivedAndRead = readBy.length > 1 || (firstUser && firstUser.id !== client.user?.id);

    if (client.user?.id !== user.id) return null

    return (
        <div style={{ margin: "5px 5px 0 0" }}>
            {receivedAndRead
                ? statusIconMap.receivedAndRead
                : (statusIconMap[status] || statusIconMap.unknown)}
        </div>
    )
}

export default CustomMessageStatus